import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {objectHelpers} from '../utils/helpers';

export const useMCCCategory = (code) => {
  const { categories } = useSelector(({ main }) => ({
    categories: main?.categories || [],
  }));

  return useMemo(() => {
    return (
      categories.find(c => c.mcc_code === code) ||
      categories.find(c => objectHelpers.isNaV(c.mcc_code))
    )?.category;
  }, [categories, code]);
}
